// Basket
export const GET_BASKET_V3 = 'GET_BASKET_V3';
export const GET_BASKET_V3_REQUEST = 'GET_BASKET_V3_REQUEST';
export const GET_BASKET_V3_RESPONSE = 'GET_BASKET_V3_RESPONSE';
export const GET_BASKET_V3_ERROR = 'GET_BASKET_V3_ERROR';

export const GET_VIEWABLE_BASKETS_V3 = 'GET_VIEWABLE_BASKETS_V3';
export const GET_VIEWABLE_BASKETS_V3_REQUEST = 'GET_VIEWABLE_BASKETS_V3_REQUEST';
export const GET_VIEWABLE_BASKETS_V3_RESPONSE = 'GET_VIEWABLE_BASKETS_V3_RESPONSE';
export const GET_VIEWABLE_BASKETS_V3_ERROR = 'GET_VIEWABLE_BASKETS_V3_ERROR';

export const SKIP_BASKET_V3 = 'SKIP_BASKET_V3';
export const SKIP_BASKET_V3_REQUEST = 'SKIP_BASKET_V3_REQUEST';
export const SKIP_BASKET_V3_RESPONSE = 'SKIP_BASKET_V3_RESPONSE';
export const SKIP_BASKET_V3_ERROR = 'SKIP_BASKET_V3_ERROR';

export const UNSKIP_BASKET_V3 = 'UNSKIP_BASKET_V3';
export const UNSKIP_BASKET_V3_REQUEST = 'UNSKIP_BASKET_V3_REQUEST';
export const UNSKIP_BASKET_V3_RESPONSE = 'UNSKIP_BASKET_V3_RESPONSE';
export const UNSKIP_BASKET_V3_ERROR = 'UNSKIP_BASKET_V3_ERROR';

export const UPDATE_BASKET_V3 = 'UPDATE_BASKET_V3';
export const UPDATE_BASKET_V3_REQUEST = 'UPDATE_BASKET_V3_REQUEST';
export const UPDATE_BASKET_V3_RESPONSE = 'UPDATE_BASKET_V3_RESPONSE';
export const UPDATE_BASKET_V3_ERROR = 'UPDATE_BASKET_V3_ERROR';

export const GET_BASKET_MENU_MEAL_V3 = 'GET_BASKET_MENU_MEAL_V3';
export const GET_BASKET_MENU_MEAL_V3_REQUEST = 'GET_BASKET_MENU_MEAL_V3_REQUEST';
export const GET_BASKET_MENU_MEAL_V3_RESPONSE = 'GET_BASKET_MENU_MEAL_V3_RESPONSE';
export const GET_BASKET_MENU_MEAL_V3_ERROR = 'GET_BASKET_MENU_MEAL_V3_ERROR';

export const MENU_REFRESH_LOADING = 'MENU_REFRESH_LOADING';
export const MENU_REFRESH_COMPLETE = 'MENU_REFRESH_COMPLETE';

export const BASKET_SUMMARY_V3 = 'BASKET_SUMMARY_V3';
export const BASKET_SUMMARY_V3_REQUEST = 'BASKET_SUMMARY_V3_REQUEST';
export const BASKET_SUMMARY_V3_RESPONSE = 'BASKET_SUMMARY_V3_RESPONSE';
export const BASKET_SUMMARY_V3_ERROR = 'BASKET_SUMMARY_V3_ERROR';

// Basket edit
export const SET_EDITED_BASKET_V3 = 'SET_EDITED_BASKET_V3';
export const UNDO_BASKET_EDITS_V3 = 'UNDO_BASKET_EDITS_V3';
export const CLEAR_EDITED_BASKET_V3 = 'CLEAR_EDITED_BASKET_V3';

export const SET_BASKET_SERVINGS_V3 = 'SET_BASKET_SERVINGS_V3';
export const UPDATE_MEAL_SERVINGS_V3 = 'UPDATE_MEAL_SERVINGS_V3';
export const ADD_PAIRED_MEALS_V3 = 'ADD_PAIRED_MEALS_V3';
export const REMOVE_PAIRED_MEAL_V3 = 'REMOVE_PAIRED_MEAL_V3';

export const ADD_MEAL_V3 = 'ADD_MEAL_V3';
export const REMOVE_MEAL_V3 = 'REMOVE_MEAL_V3';

export const CHANGE_MEAL_OPTION_V3 = 'CHANGE_MEAL_OPTION_V3';
export const UNDO_MEAL_OPTIONS_V3 = 'UNDO_MEAL_OPTIONS_V3';
export const ADD_SERVINGS_V3 = 'ADD_SERVINGS_V3';
export const REMOVE_SERVINGS_V3 = 'REMOVE_SERVINGS_V3';

export const SET_CLEAN_BASKET_EDIT_STATE_V3 = 'SET_CLEAN_BASKET_EDIT_STATE_V3';
export const HAS_BASKET_STATE_CHANGED_V3 = 'HAS_BASKET_STATE_CHANGED_V3';

// Quick Filters
export const GET_QUICK_FILTERS_V3 = 'GET_QUICK_FILTERS_V3';
export const GET_QUICK_FILTERS_V3_REQUEST = 'GET_QUICK_FILTERS_V3_REQUEST';
export const GET_QUICK_FILTERS_V3_RESPONSE = 'GET_QUICK_FILTERS_V3_RESPONSE';
export const GET_QUICK_FILTERS_V3_ERROR = 'GET_QUICK_FILTERS_V3_ERROR';

// Dashboard
export const BOOTSTRAP_DASHBOARD_V3 = 'BOOTSTRAP_DASHBOARD_V3';
export const BOOTSTRAP_DASHBOARD_V3_SUCCESS = 'BOOTSTRAP_DASHBOARD_V3_SUCCESS';
export const BOOTSTRAP_DASHBOARD_V3_ERROR = 'BOOTSTRAP_DASHBOARD_V3_ERROR';

// Menu categories
export const GET_MENU_CATEGORIES_V3 = 'GET_MENU_CATEGORIES_V3';
export const GET_MENU_CATEGORIES_V3_REQUEST = 'GET_MENU_CATEGORIES_V3_REQUEST';
export const GET_MENU_CATEGORIES_V3_RESPONSE = 'GET_MENU_CATEGORIES_V3_RESPONSE';
export const GET_MENU_CATEGORIES_V3_ERROR = 'GET_MENU_CATEGORIES_V3_ERROR';

// Menu meals
export const GET_MENU_MEALS_V3 = 'GET_MENU_MEALS_V3';
export const GET_MENU_MEALS_V3_REQUEST = 'GET_MENU_MEALS_V3_REQUEST';
export const GET_MENU_MEALS_V3_RESPONSE = 'GET_MENU_MEALS_V3_RESPONSE';
export const GET_MENU_MEALS_V3_ERROR = 'GET_MENU_MEALS_V3_ERROR';

// Menus
export const GET_MENU_V3 = 'GET_MENU_V3';
export const GET_MENU_V3_REQUEST = 'GET_MENU_V3_REQUEST';
export const GET_MENU_V3_RESPONSE = 'GET_MENU_V3_RESPONSE';
export const GET_MENU_V3_ERROR = 'GET_MENU_V3_ERROR';

// User
export const GET_USER_V3 = 'GET_USER_V3';
export const GET_USER_V3_REQUEST = 'GET_USER_V3_REQUEST';
export const GET_USER_V3_RESPONSE = 'GET_USER_V3_RESPONSE';
export const GET_USER_V3_ERROR = 'GET_USER_V3_ERROR';

export const GET_MEAL_SELLOUTS_V3 = 'GET_MEAL_SELLOUTS_V3';
export const GET_MEAL_SELLOUTS_V3_REQUEST = 'GET_MEAL_SELLOUTS_V3_REQUEST';
export const GET_MEAL_SELLOUTS_V3_RESPONSE = 'GET_MEAL_SELLOUTS_V3_RESPONSE';
export const GET_MEAL_SELLOUTS_V3_ERROR = 'GET_MEAL_SELLOUTS_V3_ERROR';

// Meal Badges
export const GET_MEAL_BADGES_V3 = 'GET_MENU_MEALS_BADGES_V3';
export const GET_MEAL_BADGES_V3_REQUEST = 'GET_MENU_MEALS_BADGES_V3_REQUEST';
export const GET_MEAL_BADGES_V3_RESPONSE = 'GET_MENU_MEALS_BADGES_V3_RESPONSE';

// Meal Prices
export const GET_MEAL_PRICES_V3 = 'GET_MEAL_PRICES_V3';
export const GET_MEAL_PRICES_V3_REQUEST = 'GET_MEAL_PRICES_V3_REQUEST';
export const GET_MEAL_PRICES_V3_RESPONSE = 'GET_MEAL_PRICES_V3_RESPONSE';
export const GET_MEAL_PRICES_V3_ERROR = 'GET_MEAL_PRICES_V3_ERROR';

export const GET_MEAL_PRICE_V3 = 'GET_MEAL_PRICE_V3';
export const GET_MEAL_PRICE_V3_REQUEST = 'GET_MEAL_PRICE_V3_REQUEST';
export const GET_MEAL_PRICE_V3_RESPONSE = 'GET_MEAL_PRICE_V3_RESPONSE';
export const GET_MEAL_PRICE_V3_ERROR = 'GET_MEAL_PRICE_V3_ERROR';
export const CLEAR_MEAL_PRICES_V3 = 'CLEAR_MEAL_PRICES_V3';

// Reviews
export const GET_COMPLETED_REVIEWS_V3 = 'GET_COMPLETED_REVIEWS_V3';
export const GET_COMPLETED_REVIEWS_V3_REQUEST = 'GET_COMPLETED_REVIEWS_V3_REQUEST';
export const GET_COMPLETED_REVIEWS_V3_RESPONSE = 'GET_COMPLETED_REVIEWS_V3_RESPONSE';
export const GET_COMPLETED_REVIEWS_V3_ERROR = 'GET_COMPLETED_REVIEWS_V3_ERROR';

// Pending Edits
export const SET_HAS_PENDING_EDITS_V3 = 'SET_HAS_PENDING_EDITS_V3';
export const CLEAR_PENDING_EDITS_V3 = 'CLEAR_PENDING_EDITS_V3';

// Meal Review Stats
export const GET_MEAL_REVIEW_STATS_V3 = 'GET_MEAL_REVIEW_STATS_V3';
export const GET_MEAL_REVIEW_STATS_V3_REQUEST = 'GET_MEAL_REVIEW_STATS_V3_REQUEST';
export const GET_MEAL_REVIEW_STATS_V3_RESPONSE = 'GET_MEAL_REVIEW_STATS_V3_RESPONSE';
export const GET_MEAL_REVIEW_STATS_V3_ERROR = 'GET_MEAL_REVIEW_STATS_V3_ERROR';

// User Behavioral Discounts
export const GET_USER_BEHAVIORAL_DISCOUNTS = 'GET_USER_BEHAVIORAL_DISCOUNTS';
export const GET_USER_BEHAVIORAL_DISCOUNTS_REQUEST = 'GET_USER_BEHAVIORAL_DISCOUNTS_REQUEST';
export const GET_USER_BEHAVIORAL_DISCOUNTS_RESPONSE = 'GET_USER_BEHAVIORAL_DISCOUNTS_RESPONSE';
export const GET_USER_BEHAVIORAL_DISCOUNTS_ERROR = 'GET_USER_BEHAVIORAL_DISCOUNTS_ERROR';

// User Behavioral Discount Claims
export const CLAIM_USER_BEHAVIORAL_DISCOUNT = 'CLAIM_USER_BEHAVIORAL_DISCOUNT';
export const CLAIM_USER_BEHAVIORAL_DISCOUNT_REQUEST = 'CLAIM_USER_BEHAVIORAL_DISCOUNT_REQUEST';
export const CLAIM_USER_BEHAVIORAL_DISCOUNT_RESPONSE = 'CLAIM_USER_BEHAVIORAL_DISCOUNT_RESPONSE';
export const CLAIM_USER_BEHAVIORAL_DISCOUNT_ERROR = 'CLAIM_USER_BEHAVIORAL_DISCOUNT_ERROR';
